import Image from "next/image";
import dynamic from "next/dynamic";
const SocialLinks = dynamic(() =>
  import("components/links/SocialLinks/SocialLinks")
);

import styles from "./AuthorInfo.module.scss";

export default function AuthorInfo({ post }) {
  const { author } = post;

  return (
    <div className={`${styles.author}`}>
      <div className={`${styles.authorImage}`}>
        {author?.profile_picture ? (
          <Image
            src={author?.profile_picture?.url}
            secure="true"
            cloudname="dail4fbms"
            publicid={author?.profile_picture?.url}
            fetchformat="auto"
            quality="auto"
            alt={"author profile picture"}
            width={72}
            height={72}
            loading="lazy"
            style={{
              borderRadius: "50%",
            }}
          />
        ) : (
          <Image
            src="/assets/img/no-profile.png"
            alt="No profile picture"
            width="48px"
            height="48px"
            layout="fixed"
            loading="lazy"
          />
        )}
      </div>

      <div className={`${styles.authorBio}`}>
        <h3 className={`${styles.authorMeta}`}>
          {author?.authorName}
          <br />
          <span className={`${styles.authorProfession}`}>
            {author?.profession}
          </span>
        </h3>
        <div className={`${styles.bioText}`}>
          <p>{author?.bio}</p>
        </div>
        <div className={`${styles.authorSocial}`}>
          <SocialLinks
            url={URL}
            blog={post}
            links={author?.socialLinks?.[0]}
            iconColor="var(--dark-text)"
            itemStyles={{ padding: "0 var(--spacing-xs)" }}
          />
        </div>
      </div>
    </div>
  );
}
